/**
 * API отдаёт `is_active` (snake_case). Неактивная кофейня: заказы недоступны, меню только для просмотра.
 */
export function isCafeInactive(shop) {
  if (!shop || typeof shop !== 'object') return false;
  return shop.is_active === false;
}

export function escapeHtml(text) {
  if (text == null) return '';
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
